export default "__VITE_ASSET__D65M6080__"